// extracted by mini-css-extract-plugin
module.exports = {"root":"ResumeDemos_root__Jo9uI","desc":"ResumeDemos_desc__1Ibki","demo":"ResumeDemos_demo__1HBOZ"};